import { User } from "@supabase/supabase-js";

import * as api from "../scripts/api";
import { bindKey } from "../scripts/binding";

const billingLink = document.getElementById("billing") as HTMLButtonElement;
const signoutLink = document.getElementById("signout-link") as HTMLButtonElement;
const emailInput = document.getElementById("email") as HTMLInputElement;
const form = document.getElementById('user-settings') as HTMLFormElement;
const submitButton = form.querySelector('button') as HTMLButtonElement;
const pendingEmail = document.getElementById("pending-email") as HTMLSpanElement

const originalSubmitText = submitButton.innerText;

const userDataDefaults: Record<string, any> = {
  'feature-update-email': true,
};

// Update the form once the page loads
(async () => {
  const user = await api.getCurrentUser();
  const stripeId = user?.app_metadata.stripeId || "" as string;

  setUserData(user?.user_metadata || {});
  if (user) renderPendingEmail(user);

  if (user?.email) {
    emailInput.value = user.email;
    emailInput.defaultValue = user.email;
  }

  // Only show the billing link if the user's stripeId starts with cus_
  if (stripeId.startsWith("cus_")) {
    billingLink.hidden = false;
  }
})();

// Get a billing url from Stripe
billingLink.addEventListener("click", async (e) => {
  e.preventDefault();
  billingLink.disabled = true;
  billingLink.innerText = "Loading…";
  const { url, error } = await api.getBillingUrl();

  if (error) {
    alert(error);
    billingLink.disabled = false;
    billingLink.innerText = "Manage Billing";
  } else if (url) {
    window.location.href = url;
  } else {
    alert("Please sign in to manage your billing.");
    billingLink.disabled = false;
    billingLink.innerText = "Manage Billing";
  }
});

// Handle sign out
signoutLink.addEventListener("click", async (e) => {
  e.preventDefault();
  const { error } = await api.signOut();
  if (error) {
    alert(error.message);
  } else {
    window.location.href = "/";
  }
});

form.addEventListener("input", () => {
  submitButton.innerText = originalSubmitText;
  submitButton.disabled = form.checkValidity() === false
});

// Handle changing the user's email address
form.addEventListener("submit", async (e) => {
  e.preventDefault();
  submitButton.disabled = true;
  submitButton.innerHTML = "Updating…";

  const { user, error } = await api.updateUserEmail(emailInput.value, getUserData());

  if (error) {
    alert(error.message);
    submitButton.disabled = false;
    submitButton.innerText = originalSubmitText;
  } else {
    submitButton.innerText = "Updated";
  }
  if (user) renderPendingEmail(user);
});

function renderPendingEmail(user: User) {
  if (user?.new_email) {
    bindKey("user.new_email", user.new_email)
    pendingEmail.hidden = false;
  }
}

// Find any form elements which have a name matching `user-data[<key>]` and set their value to the user's metadata
function setUserData(data: Record<string, any>) {
  for (const input of Array.from(form.elements) as HTMLFormElement[]) {
    const key = input.name.match(/user-data\[(.*)\]/)?.[1];
    if (!key) continue;

    const value = data[key] ?? userDataDefaults[key] ?? "";
    switch (input.type) {
      case "checkbox":
        input.checked = value;
        continue;
      case "radio":
        if (input.value === value) input.checked = true;
        continue;
    }
    input.value = value;
  }
}

// Return an object of user data from the form. Only inputs with a name matching `user-data[<key>]` will be returned.
function getUserData(): Record<string, any> {
  return Array.from<HTMLFormElement>(form.elements).reduce((acc, input) => {
    const key = input.name.match(/user-data\[(.*)\]/)?.[1];
    if (!key) return acc;

    if (input.type === "checkbox") {
      acc[key] = input.checked;
    } else if (input.type === "radio") {
      if (input.checked) acc[key] = input.value
    } else {
      acc[key] = input.value;
    }
    return acc;
  }, {} as Record<string, any>);
}
